import { type AgentInboxMessage } from '@/backendApis';
import { userStore } from '@/stores/user.store';

type MessageParties = {
  counterpart: string;
  counterpartName: string;
  counterpartLabel: string;
};

export const useMessageParties = (
  message: Pick<AgentInboxMessage, 'kind' | 'sender' | 'recipients'>
): MessageParties => {
  const ownerEmail = userStore.user?.email?.toLowerCase();
  const isOwner = (address: string) => address.toLowerCase() === ownerEmail;
  const nameOf = (address: string) =>
    (isOwner(address) && userStore.user?.name?.trim()) || address;

  if (message.kind === 'sent') {
    const [firstRecipient = ''] = message.recipients;
    const names = message.recipients.map((recipient) =>
      isOwner(recipient) ? 'you' : recipient
    );
    return {
      counterpart: firstRecipient,
      counterpartName: nameOf(firstRecipient),
      counterpartLabel: `To ${names.join(', ')}`,
    };
  }
  if (message.kind !== 'owner') {
    return {
      counterpart: message.sender,
      counterpartName: message.sender,
      counterpartLabel: message.sender,
    };
  }
  return {
    counterpart: message.sender,
    counterpartName: nameOf(message.sender),
    counterpartLabel: isOwner(message.sender) ? 'You' : message.sender,
  };
};
